// What the enterprise's plan turns on: currentUser.features from
// /authenticate (tempstickapi Billing::features()), such as
// { map: 1, alerts: 1, arc: 0, mitigation: 0, link: 1, ... }, and
// sensor_cap, the Dashboard table's limit without a plan. Everything is on
// when the API doesn't say: billing isn't open yet, or an older API.
//
// Inside the app nothing mentions plans or billing: a feature that is off
// says only that it's off for this account.

export const hasFeature = feature => {
  const features = window.currentUser && window.currentUser.features;
  return !features || features[feature] === undefined || !!features[feature];
};

export const sensorCap = () => {
  const cap = window.currentUser && window.currentUser.sensor_cap;
  return cap ? Number(cap) : null;
};

// the way to Billing, for the admins who can choose a plan, and never inside the app
export const canChoosePlan = () => !window.site.isApp
  && !!(window.currentUser && window.currentUser.billing_open)
  && window.currentUser.role >= (window.USER_ROLES ? window.USER_ROLES.ADMIN : 999);

/**
 * Why something is off, in a sentence: on the web, that the current plan
 * doesn't include it (with who can change that); inside the app, only that
 * it's off for this account.
 */
export const featureOffText = what => {
  if(window.site.isApp) {
    return `${what} is off for this account.`;
  }
  return canChoosePlan()
    ? `${what} isn't part of your current plan. Choose a plan on the Billing page to turn it on.`
    : `${what} isn't part of your current plan. An admin can choose a plan on the Billing page.`;
};

/**
 * A page of a feature the plan doesn't have: its content swapped for a short
 * notice, with a Billing button for the admins who can choose a plan. note:
 * a line more, such as what keeps working.
 */
export const showFeatureOff = ($container, title, what, note = '') => {
  const button = canChoosePlan()
    ? `<p style="margin: 18px 0 0;"><a class="button" href="${window.site.home}/billing" style="margin: 0;">See plans</a></p>`
    : '';

  $container.removeClass('loading-overlay').attr('aria-busy', 'false').html(`
    <div class="feature-off" style="max-width: 560px; margin: 48px auto; padding: 28px 32px; background: #fff; border-radius: 12px; box-shadow: 0 1px 3px rgba(16, 24, 40, .08); text-align: center;">
      <div style="width: 48px; height: 48px; margin: 0 auto 14px; border-radius: 50%; background: #eef2fd; color: #3a5fcd; display: flex; align-items: center; justify-content: center; font-size: 20px;"><i class="far fa-lock"></i></div>
      <h2 style="margin: 0 0 8px; font-size: 20px;">${title}</h2>
      <p style="margin: 0; color: #555;">${featureOffText(what)}</p>
      ${note ? `<p style="margin: 10px 0 0; color: #555;">${note}</p>` : ''}
      ${button}
    </div>
  `);
};
